export default __webpack_public_path__ + "static/media/group.f2203de2.svg";